import { DynamicRow } from "./dynamic-row.model";


export class DynamicPanel<T> extends DynamicRow<T> {

    header?: string;

    constructor(source: Partial<DynamicPanel<T>>) {
        super(source);
        this.type = "panel";
        Object.assign(this, source);
    }

}